module.exports = require("enquire.js/dist/enquire");